import React, { useEffect, useRef, useState } from "react"
import anime from 'animejs'
import { Wrapper, RichText, Background, Padder, List, Antd} from 'components'
import { Link } from 'gatsby'
import ReactPlayer from 'react-player'
import Helmet from "react-helmet"
import Particles from 'react-particles-js';
import { isDesktop } from '../../utility'



import {Layout, Deelay, Sky, Viewport, Title, Card, TextDistortion, BlockDescription, ListOfImages} from "../../components"
import theme from '../../style/theme'
import * as S from './styles'
import { getPath, getBlockDescriptionProps } from '../../utility'



function makeListOfImagesProps({title, items, pathPrefix}){

  return {
    title,
    items: items.map(e => ({
      ...e,
      image: {
        ...e.image,
        src:  getPath(e.image.src, pathPrefix)
      }
    }))
  }
}

const Icon = Antd.Icon

export default (props) => {
  const [playingVideo, setPlayingVideo] = useState(null)
  const mySlogan = useRef()
  const myVideoWrapper = useRef()
  const myContent = useRef()
  const myLoading = useRef()
  const mySubSlogan = useRef()
  const myParticlesWrapper = useRef()


  const { translations, siteMetadata } = props.pageContext

  const { slogan, sub_slogan, as2fe, banner_1, richText_1, blockDescription_1, routes, listOfImages_homepage1, listOfImages_homepage2 } = translations


  function handleScrollDown(){
    if(!myContent || typeof window === undefined) return

    anime({
      targets: window.document.scrollingElement || window.document.body || window.document.documentElement,
      scrollTop: myContent.current.offsetTop,
      duration: 500,
      easing: 'easeInOutQuad'
    });

  }



  useEffect(() => {
    if(!myLoading
      || !myLoading
      || !mySlogan
      || !mySlogan.current
      || !mySubSlogan
      || !mySubSlogan.current
      || !myParticlesWrapper
      || !myParticlesWrapper.current
      || !myVideoWrapper
      || !myVideoWrapper.current
    ) return

    var tl = anime.timeline({
      easing: 'linear',
    });
    tl
      .add({
        opacity: 0
      })
      .add({
        targets: myLoading.current,
        opacity: 0,
        duration: 250,
        easing: 'easeInOutQuad'
      })
      .add({
        targets: mySlogan.current,
        opacity: 1,
        duration: 500,
      })
      .add({
        targets: mySubSlogan.current,
        opacity: 1,
        deelay: 500
      })
      .add({
        targets: myParticlesWrapper.current,
        opacity: 1
      })
      .add({
        targets: myVideoWrapper.current,
        opacity: 1,
        complete: () => setPlayingVideo(true)
      })

    return () => anime.remove(tl)

   }, [mySlogan, myLoading,  mySubSlogan, myParticlesWrapper, myVideoWrapper])


  const industriesPath = routes.find(route => route.template === "industries")

  const { pathPrefix } = siteMetadata
  const pathSegUrl = getPath("pathseg.js", pathPrefix)
  const mainViewUrl = getPath("eyes.jpg", pathPrefix)
  const logoUrl = getPath("logo.svg", pathPrefix)

  return (
    <Layout {...props} hasTitle={false} inverted>
      <Helmet>
        <script defer async rel="preload" type="text/javascript" src={pathSegUrl} />
      </Helmet>
      <S.MainView image={mainViewUrl}>
        <S.Loading ref={myLoading}><Icon type="loading" /></S.Loading>
        <S.ParticlesWrapper ref={myParticlesWrapper}>
          {
            (isDesktop)
            ? <Deelay ms={300}>

          <Particles
            width="100vw"
            height="100vh"

            params={{
              "retina_detect": false,
              "fps_limit": 28,
              "particles": {
                "number": {
                  "value": 200,
                  "density": {
                    "enable": false
                  }
                },
                "line_linked": {
                  "enable": true,
                  "distance": 50,
                  "opacity": 0.8
                },
                "move": {
                  "speed": 3
                },
                "opacity": {
                  "anim": {
                    "enable": true,
                    "opacity_min": 0.05,
                    "speed": 2,
                    "sync": false
                  },
                  "value": 0.4
                }
              },
              "polygon": {
                "enable": true,
                "scale": 1.3,
                "type": "inline",
                "move": {
                  "radius": 13,
                },
                "url": logoUrl,
                "inline": {
                  "arrangement": "equidistant"
                },
              },
            }}
          />
          </Deelay>
          : null
          }
          <Sky color="white" />
        </S.ParticlesWrapper>
         <S.SloganWrapper>
          <Wrapper size="regular">
            <S.Slogan ref={mySlogan}>{slogan}</S.Slogan>
            <S.SubSlogan ref={mySubSlogan}><TextDistortion>{sub_slogan}</TextDistortion></S.SubSlogan>
          </Wrapper>
        </S.SloganWrapper>
        <S.MainVideoWrapper ref={myVideoWrapper}>
          <RichText
            text={banner_1}
          />
        </S.MainVideoWrapper>
        <S.IconWrapper onClick={handleScrollDown}><Icon type="down" /></S.IconWrapper>
      </S.MainView>
      <S.MainContent ref={myContent}>


        <Viewport >
          {({isVisible}) => (
              <Wrapper size="large">
            <Padder size="big">
                <RichText
                  text={richText_1}
                />
          </Padder>
              </Wrapper>
        )}

        </Viewport>



      {blockDescription_1.map((item, index) => (
        <Background color={index % 2 ? theme.colors.lightGray.secondary : 'white'} key={`${item.title}${index}`}>
          <Wrapper size="large">
            <Padder size="big">
              <Viewport>
                {() => {
                  const props = getBlockDescriptionProps({item, index, pathPrefix})
                  return <BlockDescription {...props} />
                }}
              </Viewport>
            </Padder>
          </Wrapper>
        </Background>
      ))}

        <Background color="#f9fafa">
            <Wrapper size="large">
          <Padder size="big">
            <Title title={as2fe}>
              <List columns="3">
                {industriesPath.routes.map((industry, index) => (
                  <Viewport key={industry.slug}>
                  {() => {

                    const image = {
                      src: getPath(industry.metaImage, pathPrefix)
                    }

                    const disabled = industry.hidden

                    return (
                      disabled
                      ? (
                        <S.CardWrapper disabled={disabled}>
                          <Card image={image} title={industry.label} text={industry.metaDescription} />
                        </S.CardWrapper>
                      )
                      : (
                        <Link to={`${industriesPath.slug}/${industry.slug}`}>
                          <S.CardWrapper>
                            <Card image={image} title={industry.label} text={industry.metaDescription} />
                          </S.CardWrapper>
                        </Link>
                      )
                    )
                  }

              }
              </Viewport>
              ))}
            </List>
          </Title>
        </Padder>
          </Wrapper>
      </Background>


      <Wrapper size="large">
        <Padder size="big">
          {listOfImages_homepage1 && <Padder size="big">
            <Viewport >
              {() => <ListOfImages {...makeListOfImagesProps({...listOfImages_homepage1, pathPrefix}) } />}
            </Viewport>
          </Padder>}
          {listOfImages_homepage2 && <Padder size="big">
            <Viewport >
              {() => <ListOfImages {...makeListOfImagesProps({...listOfImages_homepage2, pathPrefix}) } />}
            </Viewport>
          </Padder>}
        </Padder>
      </Wrapper>

      </S.MainContent>
    </Layout>
  )
}

